<template>
  <widget title="Past Due by Office">
    <template v-slot:content>
      <div class="centered large count">{{ pastDueByOffice.count }}</div>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'PastDueByOffice',
  components: {
    Widget
  },
  computed: {
    pastDueByOffice () {
      return store.state.dashboard.pastDueByOffice
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchPastDueByOffice')
  }
}
</script>

<style scoped>

</style>
